import { convertMillimetersToTwip, ExternalHyperlink, Footer, ImageRun, Paragraph, TextRun } from 'docx'
import ribbonImage from '@/assets/ribbon.png'

class BaseFooter {
  static async generate() {
    const ribbonBuffer = await fetch(ribbonImage)
      .then((r) => r.blob())
      .then((b) => b.arrayBuffer())

    return new Footer({
      children: [
        new Paragraph({
          children: [
            new TextRun({
              text: 'Calle Xicoténcatl No. 13, esq. Lardizábal, Colonia Centro, C.P. 90000. Conmutador: 246 46 520 50, Ext.: 32071',
              font: 'Century Gothic',
              size: 8 * 2,
            }),
          ],
          alignment: 'center',
        }),
        new Paragraph({
          children: [
            new TextRun({
              text: 'Email: ',
              font: 'Century Gothic',
              size: 8 * 2,
            }),
            new ExternalHyperlink({
              children: [
                new TextRun({
                  text: 'diradministrativa.ssc@tlaxcala.gob.mx',
                  style: 'Hyperlink',
                  font: 'Century Gothic',
                  size: 8 * 2,
                }),
              ],
              link: 'mailto:diradministrativa.ssc@tlaxcala.gob.mx',
            }),
          ],
          alignment: 'center',
        }),
        new Paragraph({
          children: [
            new ImageRun({
              data: ribbonBuffer,
              type: 'png',
              transformation: {
                width: 12240,
                height: convertMillimetersToTwip(0.5),
              },
              floating: {
                horizontalPosition: {
                  relative: 'page',
                  align: 'left',
                },
                verticalPosition: {
                  relative: 'paragraph',
                  align: 'bottom',
                },
              },
            }),
          ],
        }),
      ],
    })
  }
}

export default BaseFooter
